import numbersAPI from "@/api/numbers";
const paginationLimit = 15;
const state = () => ({
  numbers: [],
  numbersPagination: {
    items: 0,
    limit: paginationLimit,
    currentPage: 1,
  },

  isNumberPoolLoading: false,
  numberPoolErrorMessage: [],

  currentNumberPorting: {},
  currentNumberPortingLoading: false,
  currentNumberPortingError: false,
  currentNumberPortingErrorMessage: null,

  numbersInRange: {},
  numbersInRangeLoading: false,
  numbersInRangeError: "",

  createTransferOrderError: "",
  createTransferOrderLoading: false,

  sendCloaLoading: false,
  sendCloaError: false,

  checkAddressObj: '',
  checkAddressLoading: false,

  numberRanges: [],
  numberRangesLoading: false,
  numberRangesError: false,
  numberRangesErrorMessage: null,

  emailPreview: {},
  isEmailPreviewLoading: false,
  isEmailPreviewError: false,
  emailPreviewErrorResponse: null,

  isSendEmailPreviewLoading: false,
  isSendEmailPreviewError: false,
  sendEmailPreviewErrorResponse: null,

  isDeleteNumberPolling: false,
  deleteNumberLoading: {},
  deleteNumberError: false,
  deleteNumberErrorResponse: null,

  deletePortingNumberLoading: false,
  deletePortingNumberError: false,
  deletePortingNumberErrorResponse: null,

  sendCustomerNumberReserveMailLoading: false,
  sendCustomerNumberReserveMailError: false,
  sendCustomerNumberReserveMailErrorResponse: null,

  preAllocateNumberLoading: false,
  preAllocateNumberError: false,
  preAllocateNumberErrorResponse: null,

  numberId: null,
  moveNumberToAnotherProductLoading: false,
  moveNumberToAnotherProductError: false,
  moveNumberToAnotherProductErrorResponse: null,
});

const mutations = {
  SET_CHECKADDRESS(state,payload) {
    state.checkAddressObj = payload;
    state.checkAddressLoading = false;
  },
  SET_CHECKADDRESS_LOADING(state,payload) {
    state.checkAddressLoading = payload;
  },

  SET_NUMBER_POOL(state, payload) {
    state.numbers = payload.data;
    state.isNumberPoolLoading = false;
    state.numbersPagination = {
      items: payload.headers['pagination-count'],
      limit: paginationLimit,
      currentPage: payload.headers['pagination-page'],
    };
  },
  SET_NUMBER_POOL_PAGINATION(state, payload) {
    state.numbersPagination.currentPage = payload;
  },
  RESET_NUMBER_POOL(state) {
    state.numbers = [];
  },
  RESET_NUMBER_POOL_PAGINATION(state) {
    state.numbersPagination={
      items: 0,
      limit: paginationLimit,
      currentPage: 1,
    };
  },

  UPDATE_NUMBER_PORTING_SUCCESS(state, data) {
    state.currentNumberPorting = data;
  },

  GET_NUMBER_PORTING_BEGIN(state) {
    state.currentNumberPortingLoading = true;
    state.currentNumberPortingError = false;
    state.currentNumberPortingErrorMessage = null;
  },
  GET_NUMBER_PORTING_SUCCESS(state, data) {
    state.currentNumberPorting = data;
    state.currentNumberPortingLoading = false;
  },
  GET_NUMBER_PORTING_ERROR(state, error) {
    state.currentNumberPortingLoading = false;
    state.currentNumberPortingError = true;
    state.currentNumberPortingErrorMessage = error;
  },

  SET_NUMBER_IN_RANGE_LOADING(state) {
    state.numbersInRangeLoading = true;
  },
  SET_NUMBER_IN_RANGE(state, data) {
    state.numbersInRange = data;
    state.numbersInRangeLoading = false;
  },
  SET_NUMBER_IN_RANGE_ERROR(state, data) {
    state.numbersInRangeError = data;
    state.numbersInRangeLoading = false;
  },

  LOAD_NUMBERS_RANGES_BEGIN(state) {
    state.numberRangesLoading = true;
    state.numberRangesError = false;
    state.numberRangesErrorMessage = null;
  },
  LOAD_NUMBERS_RANGES_SUCCESS(state, data) {
    state.numberRanges = data;
    state.numberRangesLoading = false;
  },
  LOAD_NUMBERS_RANGES_ERROR(state, error) {
    state.numberRangesLoading = false;
    state.numberRangesError = true;
    state.numberRangesErrorMessage = error;
  },

  CREATE_TRANSFER_ORDER_BEGIN(state) {
    state.createTransferOrderLoading = true;
  },
  CREATE_TRANSFER_ORDER_SUCCESS(state) {
    state.createTransferOrderLoading = false;
  },
  CREATE_TRANSFER_ORDER_ERROR(state, data) {
    state.createTransferOrderError = data;
    state.createTransferOrderLoading = false;
  },
  
  SEND_CLOA_BEGIN(state){
    state.sendCloaLoading = true;
    state.sendCloaError = false;
    state.sendCloaErrorMsg = null;
  },
  SEND_CLOA_SUCCESS(state) {
    state.sendCloaLoading = false;
  },
  SEND_CROA_ERROR(state) {
    state.sendCloaLoading = false;
    state.sendCloaError = true;
  },

  FETCH_EMAIL_PREVIEW_BEGIN(state) {
    state.isEmailPreviewLoading = true;
    state.isEmailPreviewError = false;
    state.emailPreviewErrorResponse = null;
  },
  FETCH_EMAIL_PREVIEW_SUCCESS(state, data) {
    state.emailPreview = data;
    state.isEmailPreviewLoading = false;
  },
  FETCH_EMAIL_PREVIEW_ERROR(state, err) {
    state.isEmailPreviewLoading = false;
    state.isEmailPreviewError = true;
    state.emailPreviewErrorResponse = err;
  },

  SEND_EMAIL_PREVIEW_BEGIN(state) {
    state.isSendEmailPreviewLoading = true;
    state.isSendEmailPreviewError = false;
    state.sendEmailPreviewErrorResponse = null;
  },
  SEND_EMAIL_PREVIEW_SUCCESS(state) {
    state.isSendEmailPreviewLoading = false;
  },
  SEND_EMAIL_PREVIEW_ERROR(state, err) {
    state.isSendEmailPreviewLoading = false;
    state.isSendEmailPreviewError = true;
    state.sendEmailPreviewErrorResponse = err;
  },

  DELETE_NUMBER_BEGIN(state, id) {
    this._vm.$set(state.deleteNumberLoading, id, true);
    state.deleteNumberError = false;
    state.deleteNumberErrorResponse = null;
  },
  DELETE_NUMBER_SUCCESS(state, id) {
    this._vm.$delete(state.deleteNumberLoading, id, false);
  },
  DELETE_NUMBER_ERROR(state, payload) {
    this._vm.$delete(state.deleteNumberLoading, payload.id, false);
    state.deleteNumberError = true;
    state.deleteNumberErrorResponse = payload.err;
  },
  UPDATE_IS_DELETE_NUMBER_POLLING(state, payload) {
    state.isDeleteNumberPolling = payload;
  },

  DELETE_PORTING_NUMBER_BEGIN(state) {
    state.deletePortingNumberLoading = true;
    state.deletePortingNumberError = false;
    state.deletePortingNumberErrorResponse = null;   
  },
  DELETE_PORTING_NUMBER_SUCCESS(state) {
    state.deletePortingNumberLoading = false;
  },
  DELETE_PORTING_NUMBER_ERROR(state, err) {
    state.deletePortingNumberLoading = false;
    state.deletePortingNumberError = true;
    state.eletePortingNumberErrorResponse = err;   
  },

  SEND_CUSTOMER_NUMBER_RESERVE_MAIL_BEGIN(state) {
    state.sendCustomerNumberReserveMailLoading = true;
    state.sendCustomerNumberReserveMailError = false;
    state.sendCustomerNumberReserveMailErrorResponse = null;
  },

  SEND_CUSTOMER_NUMBER_RESERVE_MAIL_SUCCESS(state) {
    state.sendCustomerNumberReserveMailLoading = false;
  },

  SEND_CUSTOMER_NUMBER_RESERVE_MAIL_ERROR(state, err) {
    state.sendCustomerNumberReserveMailLoading = false;
    state.sendCustomerNumberReserveMailError = true;
    state.sendCustomerNumberReserveMailErrorResponse = err;
  },

  PREALLOCATE_NUMBER_BEGIN(state) {
    state.preAllocateNumberLoading = true;
    state.preAllocateNumberError = false;
    state.preAllocateNumberErrorResponse = null;
  },
  PREALLOCATE_NUMBER_SUCCESS(state) {
    state.preAllocateNumberLoading = false;
  },
  PREALLOCATE_NUMBER_ERROR(state, err) {
    state.preAllocateNumberLoading = false;
    state.preAllocateNumberError = true;
    state.preAllocateNumberErrorResponse = err;
  },

  MOVE_NUMBER_TO_ANOTHER_PRODUCT_BEGIN(state) {
    state.moveNumberToAnotherProductLoading = true;
    state.moveNumberToAnotherProductError = false;
    state.moveNumberToAnotherProductErrorResponse = null;
  },
  MOVE_NUMBER_TO_ANOTHER_PRODUCT_SUCCESS(state) {
    state.moveNumberToAnotherProductLoading = false;
  },
  MOVE_NUMBER_TO_ANOTHER_PRODUCT_ERROR(state, err) {
    state.moveNumberToAnotherProductLoading = false;
    state.moveNumberToAnotherProductError = true;
    state.moveNumberToAnotherProductErrorResponse = err;
  },
  UPDATE_NUMBER_ID(state, payload) {
    state.numberId = payload;
  },
  RESET_NUMBER_ID(state) {
    state.numberId = null;
  },
  
  RESET_STATE(state){
    state.numbers = [];
    state.isNumberPoolLoading=false;
    state.numberPoolErrorMessage=[];
    state.currentNumberPorting={};
  }
};

const actions = {
  async checkAddressAPI({commit,dispatch},data){
    commit('SET_CHECKADDRESS_LOADING',true);
    try{
      let res = await numbersAPI.checkAddress(data);
      commit('SET_CHECKADDRESS',res.data.address_check);
    }catch(err){
      commit('SET_CHECKADDRESS',err.response.data.address_check);
    }
  },

  async updatePagination({commit,dispatch},page){
    try {
      commit("SET_NUMBER_POOL_PAGINATION", page);
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
    }
  },

  async getNumbersBySearch({commit,dispatch,state},{search}){
    try {
      let data = (search.value==='*')? await numbersAPI.loadAllNumbers(search.supplier, state.numbersPagination) : await numbersAPI.loadNumbers(search.value, search.type, search.supplier, state.numbersPagination);
      commit("SET_NUMBER_POOL", data);
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
    }
  },
  
  async deleteNumber({commit, dispatch}, {id, number}) {
    commit('DELETE_NUMBER_BEGIN', id);
    try {
      const response = await numbersAPI.deleteNumber(id);

      switch(response.status) {
        case 202:
          commit('DELETE_NUMBER_SUCCESS', id);
          break;
        case 204:
          commit('DELETE_NUMBER_SUCCESS', id);
          dispatch("alerts/setAlert", {type: "success", message: `Number ${number} deleted successfully`}, { root: true });
          break;
      }
    } catch(error) {
      commit('DELETE_NUMBER_ERROR', {err: error.response.data.message, id});
      dispatch("alerts/setAlert", {type:"error", message: error.response.data.message}, { root: true });
    }
  },

  async deletePortingNumber({commit, dispatch}, {id, numberTransferRange}) {
    commit('DELETE_PORTING_NUMBER_BEGIN');
    try {
      await numbersAPI.deletePortingNumber(id);
      commit('DELETE_PORTING_NUMBER_SUCCESS');
      dispatch("alerts/setAlert", {type: "success", message: `Number transfer ${numberTransferRange} deleted successfully`}, { root: true });
    } catch(error) {
      commit('DELETE_PORTING_NUMBER_ERROR', error);     
      dispatch("alerts/setAlert", {type:"error", message: error.response.data.message}, { root: true });
    }
  },

  async sendCustomerNumberReserveMail({commit, dispatch}, {p_id}){
    commit('SEND_CUSTOMER_NUMBER_RESERVE_MAIL_BEGIN');
    try{
      await numbersAPI.sendCustomerNumberReserveMail(p_id);
      commit('SEND_CUSTOMER_NUMBER_RESERVE_MAIL_SUCCESS');
      dispatch("alerts/setAlert", {type:"success", message:"Number reserve mail sent successfully!"}, { root: true });
    }catch(error){
      commit('SEND_CUSTOMER_NUMBER_RESERVE_MAIL_ERROR', error);
      dispatch("alerts/setAlert", {type:"error", message: error.response.data.message}, { root: true });
    }
  },

  async resetNumbers({commit}){ commit("RESET_NUMBER_POOL"); },

  async resetNumberPagination({commit}){ commit("RESET_NUMBER_POOL_PAGINATION"); },

  async addNumbers({commit,dispatch},{p_id,nums}) {
    try{
      let response = await numbersAPI.addNumbers(p_id,nums);
      if(response.status === 200) {
        dispatch("alerts/setAlert", {type:"success",message:"Number added successfully!"}, { root: true });
        dispatch("products/fetchProductNumbers", p_id, { root: true });
        commit("RESET_STATE");
      } else {
        dispatch("alerts/setAlert", {type: "error",message: response.response.data.message}, { root: true });
      }
    }catch(error){
      if(error.response.status===409){
        dispatch("alerts/setAlert", {type: "error",message: error.response.data.message}, { root: true });
      }else{
        dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      }
      return;
    }
  },

  async preAllocateNumber({commit, dispatch}, {pid, number}) {
    commit('PREALLOCATE_NUMBER_BEGIN');
    try {
      await numbersAPI.preAllocateNumber(pid, number);
      commit('PREALLOCATE_NUMBER_SUCCESS');
      dispatch("alerts/setAlert", {type:"success", message:"Number added successfully!"}, { root: true });
    } catch(error) {
      commit('PREALLOCATE_NUMBER_ERROR', error);
      dispatch("alerts/setAlert", {type:"error", message: error.response.data.message}, { root: true });
    }
  },

  resetState({ commit }) {
    commit("RESET_STATE");
  },

  async transferNumber( {dispatch} , {productId, data}) {
    try{
      const res = await numbersAPI.transferNumber(productId, data);
      if(res.status === 200) {
        dispatch("alerts/setAlert", {type:"success",message:"Number added successfully!"}, { root: true });
        return true;
      } else {
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      return false;
    }
  },

  async updateNumberPorting({ commit,dispatch }, {numberRangeId, data}) {
    try{
      const res = await numbersAPI.updateNumberPorting(numberRangeId, data);
      if(res.status === 200) {
        commit("UPDATE_NUMBER_PORTING_SUCCESS", res.data);
        dispatch("alerts/setAlert", {type:"success",message:"Number edited successfully!"}, { root: true });
        return true;
      } else {
        dispatch("alerts/setAlert", {type: "error",message: res.response.data.message}, { root: true });
        return false;
      }
    }catch(error){
      dispatch("alerts/setAlert", {type:"error",message:error.response.data.message}, { root: true });
      return false;
    }
  },

  async loadNumberRanges({ commit }, productId) {
    commit('LOAD_NUMBERS_RANGES_BEGIN');
    try {
      const response = await numbersAPI.loadNumberRanges(productId);
      commit("LOAD_NUMBERS_RANGES_SUCCESS", response.data);
    } catch(error) {
      commit('LOAD_NUMBERS_RANGES_ERROR', error);
    }
  },
  
  async getNumberPorting({ commit }, { numberRangeId, data }) {
    commit('GET_NUMBER_PORTING_BEGIN')
    try {
      const response = await numbersAPI.getNumberPorting(numberRangeId, data);
      commit("GET_NUMBER_PORTING_SUCCESS", response.data);
    } catch(error) {
      commit('GET_NUMBER_PORTING_ERROR', error);
    }
  },

  async getNumbersInRange({ commit }, numberRangeId) {
    commit("SET_NUMBER_IN_RANGE_LOADING");

    try {
      const { data } = await numbersAPI.getNumbersInRange(numberRangeId);
      commit("SET_NUMBER_IN_RANGE", data);
    } catch(error) {
      commit("SET_NUMBER_IN_RANGE_ERROR", error);
      throw error;
    }
  },

  async createTransferOrder({ commit, dispatch }, { numberRange, productId }) {
    commit("CREATE_TRANSFER_ORDER_BEGIN");
    try {
      const response = await numbersAPI.createTransferOrder(numberRange);
      if(response.status === 200) {
        commit("CREATE_TRANSFER_ORDER_SUCCESS");

        const alert = {
          type: "success",
          message: "Create transfer order successful!",
        };

        dispatch("alerts/setAlert", alert, { root: true });
        dispatch("products/fetchProductNumbers", productId, { root: true });
      } else {
        const alert = {
          type: "error",
          message: `There has been an error: ${ response.response.data.message }`,
        };
        
        dispatch("alerts/setAlert", alert, { root: true });
      }
    } catch(error) {
      commit("CREATE_TRANSFER_ORDER_ERROR", error);

      const alert = {
        type: "error",
        message: `There has been an error: ${error ? error.response.data.message : 500}`,
      };

      dispatch("alerts/setAlert", alert, { root: true });
      throw error;
    }
  },

  async sendCloa({ commit, dispatch }, { numberRangeId }) {
    commit("SEND_CLOA_BEGIN");
    try {
      await numbersAPI.sendCloa(numberRangeId);
      commit("SEND_CLOA_SUCCESS");
      const alert = {
        type: "success",
        message: "CLOA sent",
      };

      dispatch("alerts/setAlert", alert, { root: true });
    } catch(error) {
      commit("SEND_CROA_ERROR");
      const alert = {
        type: "error",
        message: `There has been an error: ${error ? error.response.data.message : 500}`,
      };

      dispatch("alerts/setAlert", alert, { root: true });
      throw error;
    }
  },

  async fetchEmailPreview({commit}, {emailType, numberTransferId} ) {
    commit('FETCH_EMAIL_PREVIEW_BEGIN');

    try {
      let response = {};
      switch(emailType) {
        case 'mismatch':
          response = await numbersAPI.fetchEmailPreviewMismatch(numberTransferId);
          break;
        case 'cancellation':
          response = await numbersAPI.fetchEmailPreviewCancellation(numberTransferId);
          break;
      }

      commit('FETCH_EMAIL_PREVIEW_SUCCESS', response.data);
    } catch(err) {
      commit('FETCH_EMAIL_PREVIEW_ERROR', err.response.data.message);
    }
  },

  async sendEmailPreview({commit, dispatch}, {emailType, numberTransferId}) {
    commit('SEND_EMAIL_PREVIEW_BEGIN');

    try {
      let response = {};
      switch(emailType) {
        case 'mismatch':
          response = await numbersAPI.sendEmailPreviewMismatch(numberTransferId);
          break;
        case 'cancellation':
          response = await numbersAPI.sendEmailPreviewCancellation(numberTransferId);
          break;
      }

      if (response.status === 200) {
        commit('SEND_EMAIL_PREVIEW_SUCCESS');
        dispatch("alerts/setAlert", {type:'success', message: 'Email sent successfully!'}, { root: true });
      } else {
        commit('SEND_EMAIL_PREVIEW_ERROR', response.response.data.message);
        dispatch("alerts/setAlert", {type: 'error', message: response.response.data.message}, { root: true });
      }
      
    } catch(err) {
      commit('SEND_EMAIL_PREVIEW_ERROR', err.response.data.message);
      dispatch("alerts/setAlert", {type: 'error', message: err.response.data.message}, { root: true });
    }
  },

  async moveNumberToAnotherProduct({ commit, dispatch }, payload) {
    commit('MOVE_NUMBER_TO_ANOTHER_PRODUCT_BEGIN');
    try {
      const data = await numbersAPI.moveNumberToAnotherProduct(payload);
      dispatch('alerts/setAlert', {type: 'success', message: data.data.message }, { root: true });
      commit('MOVE_NUMBER_TO_ANOTHER_PRODUCT_SUCCESS');
    } catch(err) {
      dispatch("alerts/setAlert", {type: 'error', message: err.response.data.message }, { root: true });
      commit('MOVE_NUMBER_TO_ANOTHER_PRODUCT_ERROR', err);
    }
  }
};

const getters = {
  pagination: (state) => {
    let pagination = state.numbersPagination;
    return {
      ...pagination,
      totalPages: getTotalPages(pagination),
    };
  },
  getNumbersWithRange: (state) => {
    return state.numbers.map((e) => {
      return {
        ...e,
        range: getRange(e),
      };
    });
  },

  getSendCloaLoading: state => state.sendCloaLoading,
  getSendCloaError: state => state.sendCloaError,
  
  getEmailPreview: state => state.emailPreview,
  getIsEmailPreviewLoading: state => state.isEmailPreviewLoading,
  getIsEmailPreviewError: state => state.isEmailPreviewError,
  getEmailPreviewErrorResponse: state => state.emailPreviewErrorResponse,
  
  getIsSendEmailPreviewLoading: state => state.isSendEmailPreviewLoading,
  getIsSendEmailPreviewError: state => state.isSendEmailPreviewError,
  getSendEmailPreviewErrorResponse: state => state.sendEmailPreviewErrorResponse,

  getIsDeleteNumberPolling: state => state.isDeleteNumberPolling,
  getDeleteNumberLoading: state => Object.values(state.deleteNumberLoading).some(val => val),
  getSingleDeleteNumberLoading: state => id => state.deleteNumberLoading[id],
  getDeleteNumberError: state => state.deleteNumberError,
  getDeleteNumberErrorResponse: state => state.deleteNumberErrorResponse,

  getDeletePortingNumberLoading: state => state.deletePortingNumberLoading,
  getDeletePortingNumberError: state => state.deletePortingNumberError,
  getDeletePortingNumberErrorResponse: state => state.deletePortingNumberErrorResponse,

  getNumberRanges: state => state.numberRanges,
  getNumberRange: state => numberRangeId  => state.numberRanges.find(range => range.id === numberRangeId) || {},

  getCurrentNumberPorting: state => state.currentNumberPorting,
  getCurrentNumberPortingLoading: state => state.currentNumberPortingLoading,
  getCurrentNumberPortingError: state => state.currentNumberPortingError,
  getCurrentNumberPortingErrorMessage: state => state.currentNumberPortingErrorMessage,

  getSendCustomerNumberReserveMailLoading: state => state.sendCustomerNumberReserveMailLoading,
  getSendCustomerNumberReserveMailError: state => state.sendCustomerNumberReserveMailError,
  getSendCustomerNumberReserveMailErrorResponse: state => state.sendCustomerNumberReserveMailErrorResponse,
  
  getPreAllocateNumberLoading: state => state.preAllocateNumberLoading,
  getPreAllocateNumberError: state => state.preAllocateNumberError,
  getPreAllocateNumberErrorResponse: state => state.preAllocateNumberErrorResponse,

  getNumberId: state => state.numberId,
  getMoveNumberToAnotherProductLoading: state => state.moveNumberToAnotherProductLoading,
  getMoveNumberToAnotherProductError: state => state.moveNumberToAnotherProductError,
  getMoveNumberToAnotherProductErrorResponse: state => state.moveNumberToAnotherProductErrorResponse,
};

const getTotalPages = (val) => {
  let pages = Math.floor(val.items/val.limit);
  pages += ((val.items%val.limit)>0)?1:0;
  return pages;
};

const getRange = (val) => {
  return `${val.range_start} ~ ${val.range_end}`;
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
